import useInputId from "@ui/hooks/unique-id";
import React, { ReactNode } from "react";

export interface RadioProps extends React.ComponentProps<"input"> {
  name: string;
  label?: ReactNode;
  error?: string;
  checked?: boolean;
  description?: ReactNode;
  className?: string;
}

export function Radio(props: RadioProps) {
  const id = useInputId(props);

  return (
    <div className="flex items-start">
      <div className="flex items-center h-5">
        <input
          type="radio"
          id={id}
          aria-describedby={`${id}-description`}
          value={props.value}
          checked={props.checked}
          name={props.name}
          onChange={props?.onChange}
          className="focus:ring-purple-500 w-5 h-5 text-purple-600 border-border checked:bg-purple-600"
        />
      </div>
      <div className="ml-3 text-sm">
        <label htmlFor={id} className="block text-sm font-medium text-foreground">
          {props.label}
        </label>
        {props.description && (
          <p id={`${id}-description`} className="text-muted-foreground">
            {props.description}
          </p>
        )}
      </div>
    </div>
  );
}

export function RadioGroup({
  label,
  description,
  children,
}: {
  label: ReactNode;
  description?: string;
  children: ReactNode;
}) {
  return (
    <fieldset>
      <div className="mb-3">
        <legend className="block text-sm font-medium text-foreground">{label}</legend>
      </div>
      {description && <p className="text-sm text-muted-foreground">{description}</p>}
      <div className="space-y-4">{children}</div>
    </fieldset>
  );
}
